(() => {
  const FALLBACK_IMAGE =
    'https://cdn.shopify.com/s/files/1/1016/7241/9659/files/placeholder.png?v=1790264045';

  /**
   * Globale Styles für alle Panasia-Fallback-Bilder.
   * Wird nur einmal eingefügt.
   */
  function addFallbackStyles() {
    if (document.getElementById('panasia-product-placeholder-styles')) {
      return;
    }

    const style = document.createElement('style');

    style.id = 'panasia-product-placeholder-styles';

    style.textContent = `
      .panasia-product-placeholder {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
      }

      .panasia-product-placeholder--pdp {
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        border-radius: 6px;
      }

      .panasia-product-placeholder--cart {
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        border-radius: 6px;
      }

      .panasia-placeholder-media {
        width: 100%;
        aspect-ratio: 1 / 1;
        overflow: hidden;
        border-radius: 6px;
      }

      .panasia-placeholder-media img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .panasia-placeholder-pdp-item {
        width: 100%;
      }

      .panasia-placeholder-gallery .slider-buttons {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  }


  /**
   * Erzeugt ein neues Placeholder-Bild.
   */
  function createFallbackImage(modifier = '') {
    const img = document.createElement('img');

    img.src = FALLBACK_IMAGE;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';

    img.dataset.panasiaFallback = 'true';

    img.className = 'panasia-product-placeholder';

    if (modifier) {
      img.classList.add(
        `panasia-product-placeholder--${modifier}`
      );
    }

    return img;
  }


  /**
   * ============================================================
   * 1. COLLECTION / PRODUCT CARDS
   * ============================================================
   *
   * Ignite:
   *
   * <div class="media media--transparent media--no-photo">
   *   <svg>...</svg>
   * </div>
   */
  function replaceNoPhotoContainer(container) {
    if (!container) {
      return;
    }

    if (container.dataset.panasiaFallback === 'true') {
      return;
    }

    container.dataset.panasiaFallback = 'true';

    container.innerHTML = '';

    container.appendChild(
      createFallbackImage()
    );
  }


  /**
   * ============================================================
   * 2. PRODUKTDETAILSEITE
   * ============================================================
   *
   * Ignite rendert bei Produkten ohne Bild:
   *
   * .product.product--no-media
   *
   * und darin:
   *
   * <ul class="product__media-list ..."></ul>
   *
   * Diese Liste ist komplett leer.
   */
  function replaceEmptyProductGallery(product) {
    if (!product) {
      return;
    }

    if (product.dataset.panasiaFallback === 'true') {
      return;
    }

    const mediaGallery =
      product.querySelector('media-gallery');

    if (!mediaGallery) {
      return;
    }

    const mediaList =
      mediaGallery.querySelector('.product__media-list');

    if (!mediaList) {
      return;
    }

    /**
     * Nur eingreifen, wenn wirklich kein Produktmedium
     * vorhanden ist.
     */
    const imageCount =
      parseInt(
        mediaGallery.dataset.numImages || '0',
        10
      );

    const existingMedia =
      mediaList.querySelector(
        'img, video, model-viewer, iframe'
      );

    if (imageCount > 0 || existingMedia) {
      return;
    }

    product.dataset.panasiaFallback = 'true';

    /**
     * Ignite-Klasse entfernen, damit das Theme den
     * Medienbereich wieder als normalen Produktbereich
     * behandelt.
     */
    product.classList.remove('product--no-media');

    /**
     * Media Gallery als Placeholder-Gallery markieren.
     */
    mediaGallery.classList.add(
      'panasia-placeholder-gallery'
    );

    /**
     * Ignite intern mitteilen:
     * Es gibt jetzt visuell ein Element.
     */
    mediaGallery.dataset.numImages = '1';

    /**
     * Neues Gallery-Element erzeugen.
     */
    const li = document.createElement('li');

    li.className =
      'product__media-item grid__item slider__slide panasia-placeholder-pdp-item';

    li.dataset.panasiaFallback = 'true';

    const media = document.createElement('div');

    media.className =
      'media media--transparent panasia-placeholder-media';

    const img = createFallbackImage('pdp');

    img.loading = 'eager';

    media.appendChild(img);
    li.appendChild(media);
    mediaList.appendChild(li);

    /**
     * Slider-Counter korrigieren.
     */
    const currentCounter =
      mediaGallery.querySelector(
        '.slider-counter--current'
      );

    const totalCounter =
      mediaGallery.querySelector(
        '.slider-counter--total'
      );

    if (currentCounter) {
      currentCounter.textContent = '1';
    }

    if (totalCounter) {
      totalCounter.textContent = '1';
    }
  }


  /**
   * ============================================================
   * 3. WARENKORB / CART DRAWER
   * ============================================================
   *
   * Bei Produkten ohne Bild rendert Ignite:
   *
   * <td class="cart-item__media ...">
   *   <svg>...</svg>
   * </td>
   */
  function replaceCartPlaceholder(container) {
    if (!container) {
      return;
    }

    if (container.dataset.panasiaFallback === 'true') {
      return;
    }

    /**
     * Wenn bereits ein echtes Bild vorhanden ist:
     * nichts verändern.
     */
    const existingImage =
      container.querySelector('img');

    if (existingImage) {
      return;
    }

    const svg =
      container.querySelector('svg');

    if (!svg) {
      return;
    }

    container.dataset.panasiaFallback = 'true';

    const img =
      createFallbackImage('cart');

    /**
     * Ignite-Cart-Klasse ergänzen.
     * Dadurch übernimmt das Bild möglichst viele
     * bestehende Größenregeln des Themes.
     */
    img.classList.add('cart-item__image');

    svg.replaceWith(img);
  }


  /**
   * ============================================================
   * 4. DEFEKTE BILDER
   * ============================================================
   *
   * Falls ein Produkt zwar ein IMG besitzt,
   * die Bilddatei aber nicht geladen werden kann.
   */
  function replaceBrokenImage(img) {
    if (!img) {
      return;
    }

    if (
      img.dataset.panasiaFallback === 'true' ||
      img.src === FALLBACK_IMAGE
    ) {
      return;
    }

    img.dataset.panasiaFallback = 'true';

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    const picture =
      img.closest('picture');

    if (picture) {
      picture
        .querySelectorAll('source')
        .forEach((source) => {
          source.remove();
        });
    }

    img.src = FALLBACK_IMAGE;

    img.classList.add(
      'panasia-product-placeholder'
    );
  }


  /**
   * ============================================================
   * 5. SCANNER
   * ============================================================
   */
  function scan(root = document) {
    if (!root) {
      return;
    }


    /**
     * --------------------------------------------
     * COLLECTION / PRODUCT CARDS
     * --------------------------------------------
     */

    const noPhotoContainers = [];

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches &&
      root.matches('.media--no-photo')
    ) {
      noPhotoContainers.push(root);
    }

    if (root.querySelectorAll) {
      noPhotoContainers.push(
        ...root.querySelectorAll(
          '.media--no-photo'
        )
      );
    }

    noPhotoContainers.forEach(
      replaceNoPhotoContainer
    );


    /**
     * --------------------------------------------
     * PRODUKTDETAILSEITE
     * --------------------------------------------
     */

    const noMediaProducts = [];

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches &&
      root.matches('.product.product--no-media')
    ) {
      noMediaProducts.push(root);
    }

    if (root.querySelectorAll) {
      noMediaProducts.push(
        ...root.querySelectorAll(
          '.product.product--no-media'
        )
      );
    }

    noMediaProducts.forEach(
      replaceEmptyProductGallery
    );


    /**
     * Sicherheit:
     *
     * Manche Ignite-Skripte könnten die Klasse
     * product--no-media verändern.
     *
     * Deshalb suchen wir zusätzlich direkt nach
     * Media Galleries mit 0 Bildern.
     */
    if (root.querySelectorAll) {
      root
        .querySelectorAll(
          'media-gallery[data-num-images="0"]'
        )
        .forEach((gallery) => {
          const product =
            gallery.closest('.product');

          if (product) {
            replaceEmptyProductGallery(product);
          }
        });
    }


    /**
     * --------------------------------------------
     * CART / CART DRAWER
     * --------------------------------------------
     */

    const cartMediaContainers = [];

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches &&
      root.matches('.cart-item__media')
    ) {
      cartMediaContainers.push(root);
    }

    if (root.querySelectorAll) {
      cartMediaContainers.push(
        ...root.querySelectorAll(
          '.cart-item__media'
        )
      );
    }

    cartMediaContainers.forEach(
      replaceCartPlaceholder
    );


    /**
     * --------------------------------------------
     * KAPUTTE IMG-ELEMENTE
     * --------------------------------------------
     */

    const images = [];

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches &&
      root.matches('img')
    ) {
      images.push(root);
    }

    if (root.querySelectorAll) {
      images.push(
        ...root.querySelectorAll('img')
      );
    }

    images.forEach((img) => {
      if (
        img.dataset.panasiaFallback === 'true' ||
        img.src === FALLBACK_IMAGE
      ) {
        return;
      }

      if (
        img.complete &&
        img.naturalWidth === 0 &&
        img.src
      ) {
        replaceBrokenImage(img);
      }
    });
  }


  /**
   * ============================================================
   * 6. INITIALISIERUNG
   * ============================================================
   */
  function init() {

    addFallbackStyles();

    /**
     * Initiale Seite prüfen.
     */
    scan(document);


    /**
     * Defekte Bilder auch während des Ladens abfangen.
     */
    document.addEventListener(
      'error',
      (event) => {
        const target = event.target;

        if (
          target &&
          target.tagName === 'IMG' &&
          target.src !== FALLBACK_IMAGE
        ) {
          replaceBrokenImage(target);
        }
      },
      true
    );


    /**
     * Ignite lädt viele Elemente dynamisch:
     *
     * - Collection Pagination
     * - Infinite Scroll
     * - Predictive Search
     * - Recommendations
     * - Quick Buy
     * - Cart Drawer
     * - Cart Updates
     *
     * Daher beobachten wir den DOM.
     */
    const observer =
      new MutationObserver((mutations) => {

        mutations.forEach((mutation) => {

          mutation.addedNodes.forEach((node) => {

            if (
              node.nodeType ===
              Node.ELEMENT_NODE
            ) {
              scan(node);
            }

          });

        });

      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /**
   * ============================================================
   * 7. START
   * ============================================================
   */
  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();